export default __webpack_public_path__ + "static/media/presentation.06898bdc.png";